
import { defineComponent } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import store from '@/store'

export default defineComponent({
  props: {
    maxPagesShown: { type: Number, default: 5 },
    prevButtonContent: { type: String, default: undefined },
    nextButtonContent: { type: String, default: undefined }
  },
  emits: ['inputChanged'],
  setup(props, { emit }) {
    const { useActions } = createNamespacedHelpers('pagination')
    const { updatePage } = useActions(['updatePage'])

    const clickHandler = (page: number) => {
      updatePage(page)
      emit('inputChanged')
    }

    return { store, clickHandler }
  }
})
